import { ACCOUNT_PRO_ROLES } from '../../../../../../../constants/account-roles';

/**
 * @enum PHOTO_MANAGER_SUBSCRIPTION_BILLING_PERIOD
 * @type {{YEARLY: string, MONTHLY: string}}
 */
export const PHOTO_MANAGER_SUBSCRIPTION_BILLING_PERIOD = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
};

/**
 * PhotoManagerSubscription features.
 *
 * @type {string[]}
 */
export const PRO_PHOTO_MANAGER_SUBSCRIPTION_FEATURES = [
  'Shoot to print -  complete workflow automation',
  'Facial & jersey recognition-powered proof delivery',
  'FaceBlocker patented copyright protection',
  'SMS & Email marketing automations',
  'QR code, SMS & Roster-based onboarding',
  'Custom, branded prints (lab integrations)',
  'Real-time sales reporting and analytics',
  '1TB photo & video free storage (with affordable upgrades)',
];

export const PHOTO_MANAGER_SUBSCRIPTION_FEATURES = [
  '1TB photo & video storage',
  'Unlimited contributors & photo moderation',
  'Easy QR code & SMS gallery inviting',
  'Web and mobile app viewing',
  'Automated slideshow builder',
  'Standard & custom print ordering',
  'Custom tagging & searching',
  'Automated photo branding',
  'Personalized direct mail builder',
];

/**
 * Checks if an Account is eligible for a PhotoManager subscription trial.
 *
 * @param {Object} [account] The Account.
 * @returns {*}
 */
export const isEligibleForPhotoManagerFreeTrial = account => {
  return (
    !account?.pro_settings?.has_free_photo_manager &&
    account?.photo_manager_subscription_free_trial_enabled
  );
};

/**
 * Checks if an Account is eligible for a PRO (1y) PhotoManager subscription trial.
 *
 * @param {Object} [account] The Account.
 * @returns {*}
 */
export const isEligibleForPROPhotoManagerFreeTrial = account => {
  return (
    isEligibleForPhotoManagerFreeTrial(account) &&
    account?.roles?.find(role => role === ACCOUNT_PRO_ROLES.PHOTOGRAPHER)
  );
};
